import * as React from 'react'

import { useNavigate } from 'react-router-dom'

import { localStorageClient } from '@/lib/db/local/client'

import { AppContext } from '@/components/base/appcontext'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'

import { AlertTriangle } from 'lucide-react'

const OngoingWorkoutAlert = React.memo(function OngoingWorkoutAlert() {
    const navigate = useNavigate()
    const appContext = React.useContext(AppContext)
    const [ongoingData, setOngoingData] = React.useState<{
        programId: string
        ongoingWorkout: any
    } | null>(null)

    React.useEffect(() => {
        let isMounted = true

        const fetchOngoingWorkout = async () => {
            try {
                const version = appContext.geti18n('local-lesson-version')
                const [programId, ongoingWorkout] =
                    await localStorageClient.getOngoingWorkout(version)
                if (isMounted && ongoingWorkout) {
                    setOngoingData({ programId, ongoingWorkout })
                }
            } catch (error) {
                console.error('Error fetching ongoing workout:', error)
            }
        }

        fetchOngoingWorkout()

        return () => {
            isMounted = false
        }
    }, [appContext])

    const handleContinue = React.useCallback(() => {
        if (ongoingData?.programId) {
            navigate(`/schedule/${ongoingData.programId}/details`)
        }
    }, [navigate, ongoingData])

    if (!ongoingData) return null

    return (
        <Alert className="my-2 transition-transform duration-1000 ease-out rounded-lg">
            <AlertTriangle className="h-4 w-4" />
            <AlertDescription className="flex items-center justify-between w-full">
                <Typography>
                    {appContext.geti18n('ongoingworkout.alert.text')}
                </Typography>
                <Button
                    variant="ghost"
                    size="sm"
                    className="text-green-600"
                    onClick={handleContinue}
                >
                    {appContext.geti18n('ongoingworkout.continue.text')}
                </Button>
            </AlertDescription>
        </Alert>
    )
})

export default OngoingWorkoutAlert
